module.exports = __webpack_public_path__ + "svg/ra-frontdesk.bdb7871.svg";